import React, { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import useAutoRefresh from "@/hooks/useAutoRefresh";
import { CheckCircle2, AlertTriangle, Moon } from "lucide-react";

const STYLES = {
  fresh: { cls: "bg-emerald-50 text-emerald-800 border-emerald-200", Icon: CheckCircle2, label: "Dati aggiornati" },
  stale: { cls: "bg-red-50 text-red-800 border-red-300", Icon: AlertTriangle, label: "Dati non aggiornati" },
  off_hours: { cls: "bg-slate-50 text-slate-600 border-slate-200", Icon: Moon, label: "Fuori fascia operativa" },
};

export const FreshnessBadge = ({ freshness: external }) => {
  const [own, setOwn] = useState(null);
  const load = useCallback(async () => {
    if (external) return;
    const { data } = await api.get("/admin/market-import/status");
    setOwn(data.freshness);
  }, [external]);
  useEffect(() => { load(); }, [load]);
  useAutoRefresh(load, 60_000);

  const f = external || own;
  if (!f) return null;
  const s = STYLES[f.state] || STYLES.off_hours;
  return (
    <div className={`inline-flex items-center gap-2 px-3 py-2 rounded-lg border text-sm ${s.cls}`} data-testid={`freshness-badge-${f.state}`}>
      <s.Icon size={15} className="flex-shrink-0" />
      <span className="font-semibold">Freschezza: {s.label}</span>
      <span className="text-xs opacity-80" data-testid="freshness-last-import">
        · ultimo import Bridge {f.last_import_at ? fmtDateTime(f.last_import_at) : "—"}
        {f.state === "stale" && ` · nessun nuovo import da oltre ${f.max_gap_minutes} min`}
        {f.state === "off_hours" && ` · controllo attivo ${f.window}`}
      </span>
    </div>
  );
};

export default FreshnessBadge;
